export const SET_DOWNLOAD_SPEED_TIERS = 'SET_DOWNLOAD_SPEED_TIERS';

export const setDownloadSpeedTiers = downloadSpeedTiers => ({
  type: SET_DOWNLOAD_SPEED_TIERS,
  value: {downloadSpeedTiers},
});
